import(/* webpackMode: "eager" */ "/app/apps/web/src/app/page.tsx");
